import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const Copyright = () => {
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl = countryCode === "AU" ? "au" : "com";

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {t("policies.copyrightLabel")}
      {" © "}
      <Link
        style={{ color: "#76bc21", textDecoration: "none" }}
        href={`https://www.lifesafer.${countryUrl}/`}
        target="_blank"
        rel="noopener noreferrer"
      >
        LifeSafer
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};
